import React from "react";
import cx from "classnames";

export default ({ name, className, errors = [], ...props }) => {
    return (
        <>
            <div className="mt-1">
                <textarea
                    rows={8}
                    name={name}
                    className={cx(
                        "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                        {
                            "border-red-300": errors.length,
                        },
                        className
                    )}
                    {...props}
                />
            </div>
            {errors && <p className="mt-2 text-sm text-red-600">{errors}</p>}
        </>
    );
};
